export const GET_ALL_NEWS = 'GET_ALL_NEWS';
export const CURRENT_PAGE_NEWS = 'CURRENT_PAGE_NEWS';


